import { z } from "zod";

import { EMBEDDING_MODELS } from "../../lib/embedding.model";
import { MetadataSchema } from "../completions/completions.models";

export const SingleEmbeddingInputSchema = z.union([
  z.string(),
  z.array(z.number()),
]);

export const MultiEmbeddingInputSchema = z.union([
  z.array(z.string()),
  z.array(z.array(z.number())),
]);

export const EmbeddingInputSchema = z.union([
  SingleEmbeddingInputSchema,
  MultiEmbeddingInputSchema,
]);

/**
 * OpenAI-compatible embedding request payload
 * Based on https://platform.openai.com/docs/api-reference/embeddings/create
 */
export const EmbeddingRequestPayloadSchema = z.object({
  input: EmbeddingInputSchema,
  model: z.enum(EMBEDDING_MODELS, {
    errorMap: () => ({
      message: `Invalid embedding model provided. View supported embedding models at https://inference.net/models.`,
    }),
  }),
  encoding_format: z.enum(["float", "base64"]).default("float"),
  dimensions: z.number().int().positive().optional(),
  user: z.string().optional(),
  metadata: MetadataSchema.optional(),
});

export type SingleEmbeddingInput = z.infer<typeof SingleEmbeddingInputSchema>;
export type MultiEmbeddingInput = z.infer<typeof MultiEmbeddingInputSchema>;
export type EmbeddingInput = z.infer<typeof EmbeddingInputSchema>;
export type EmbeddingRequestPayload = z.infer<
  typeof EmbeddingRequestPayloadSchema
>;

export function isSingleEmbeddingRequest(
  input: EmbeddingInput,
): input is SingleEmbeddingInput {
  return (
    typeof input === "string" ||
    (Array.isArray(input) && typeof input[0] === "number")
  );
}
